import { gql } from "./api";

interface CreateActivityInput {
  uuid: string;
  token: string;
  user_uuid: string;
  activity_label: string;
}

export const createActivity = async ({
  uuid,
  token,
  user_uuid,
  activity_label
}: CreateActivityInput) => {
  const response = await gql({
    query: `
      mutation CreateActivity {
        createActivity(
          createActivityInput: {
            token: "${token}",
            uuid: "${uuid}",
            user_uuid: "${user_uuid}",
            activity_label: "${activity_label}"
          }
        ) {
          exp
          label
          level
          activity
          activity_chart
          content {
            EN
            NL
          }
        }
      }
    `,
    returnFunc: 'createActivity'
  });

  return response;
};
